module.exports = __webpack_public_path__ + "img/trend-none.d3f2f115.svg";